import { render, staticRenderFns } from "./followAdd.vue?vue&type=template&id=e9c7fc48"
import script from "./followAdd.vue?vue&type=script&lang=js"
export * from "./followAdd.vue?vue&type=script&lang=js"
import style0 from "./followAdd.vue?vue&type=style&index=0&id=e9c7fc48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports